import { useEffect } from 'react';

import { usePathname } from 'expo-router';

import { RunningExperiments, useExperiments } from 'state/experiments';
import { routes } from 'utils/routing';

export const usePaymentCheckoutRedesignExperiment = () => {
  const { variant, logExposure } = useExperiments();

  const pathname = usePathname();

  useEffect(() => {
    if (pathname === routes.cartPayment) {
      logExposure(RunningExperiments.PaymentCheckoutRedesign);
    }
  }, [pathname, logExposure]);

  return variant(RunningExperiments.PaymentCheckoutRedesign, 'treatment', {
    skipExposureLogging: true,
  });
};
